import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Suppress AbortErrors
        if (error.name === 'AbortError' || error.message?.includes('aborted')) {
            return { hasError: false };
        }
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Only log non-abort errors
        if (error.name !== 'AbortError' && !error.message?.includes('aborted')) {
            console.error('Caught error:', error, errorInfo);
        }
    }

    render() {
        if (this.state.hasError) {
            return <div>Something went wrong. Please refresh the page.</div>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
